import "./CookiePolicy.module.css";
import Header from "@/reusable_sections/Header";
import HeroIntroduction from "./sections/HeroIntroduction";
import CookieTypesAndPurposes from "./sections/CookieTypesAndPurposes";
import ManagementRightsOptions from "./sections/ManagementRightsOptions";
import Footer from "@/reusable_sections/Footer";
export default function CookiePolicyPage() {
  return <div>
      <Header />
      <HeroIntroduction />
      <CookieTypesAndPurposes />
      <ManagementRightsOptions />
      <Footer />
    </div>;
}